var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakeSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2492 7.66835L12.0833 6.83419L11.2492 6.00002L9.16666 8.08252L4.16749 3.08335L6.24999 1.00085L5.41582 0.166687L4.58166 1.00085L3.74749 0.166687L2.49916 1.41502L1.66499 0.580854L0.830823 1.41502L1.66499 2.24919L0.416656 3.49752L1.25082 4.33169L0.416656 5.16585L1.25082 6.00002L3.33332 3.91752L8.33249 8.91669L6.24999 10.9992L7.08416 11.8334L7.91832 10.9992L8.75249 11.8334L10.0008 10.585L10.835 11.4192L11.6692 10.585L10.835 9.75085L12.0833 8.50252L11.2492 7.66835Z",
    fill: "#C9C7D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeSchedule);
export default __webpack_public_path__ + "static/media/make_schedule.686dbafda2dde777a2fda72ac8dad632.svg";
export { ForwardRef as ReactComponent };